/**
 * 系统管理  角色管理
 */
<template>
  <div class="ph-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item style="margin-top: 20px;">角色管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">

      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.role_name" placeholder="输入角色名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="60">
      </el-table-column>
      <el-table-column align="center" prop="role_id" v-if="idShow">
      </el-table-column>
      <el-table-column  align="center" prop="role_name" label="角色名称" width="200">
      </el-table-column>
      <el-table-column  align="center" prop="role_sign" label="角色签名" width="200">
      </el-table-column>
      <el-table-column  align="center" prop="add_time" label="添加时间" width="200">
      </el-table-column>
      <el-table-column  align="center" prop="upd_time" label="修改时间" width="200">
      </el-table-column>
      <el-table-column  align="center" prop="real_name" label="操作人" width="200">
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
          <el-button size="mini" type="success" @click="menuAccess(scope.$index, scope.row)">菜单权限</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="角色名称" prop="role_name">
          <el-input size="small" v-model="editForm.role_name" auto-complete="off" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="角色签名" prop="role_sign">
          <el-input size="small" v-model="editForm.role_sign" auto-complete="off" placeholder="请输入角色签名"></el-input>
        </el-form-item>
      <el-form-item label="角色权限">
        <el-tree class="treeclass" 
                  ref="tree" 
                  :data="treeData" 
                  default-expand-all=""
                  :props="defaultProps"
                  :default-checked-keys="checkmenu"
                  node-key="id" 
                  show-checkbox>
        </el-tree>
    </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
    <!-- 菜单权限 -->
    <el-dialog title="菜单权限" :visible.sync="menuAccessshow" width="30%" @click='closeDialog("perm")'>
      <el-tree ref="tree" default-expand-all="" :data="RoleRight" :props="RoleRightProps" :default-checked-keys="checkmenu" node-key="id" show-checkbox>
      </el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("perm")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="menuPermSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  roleList,
  roleSave,
  roleDelete,
  rolePwd,
  RoleRightTree,
  RoleRightSave,
  ModuleList,
  roleInfo
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      idShow:false,
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
       // 选中
      checkmenu: [],

      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      menuAccessshow: false, //控制数据权限显示与隐藏
      title: '添加',
      editForm: {
        role_id: '',
        role_name: '',
        permission_id: '',
        role_sign: '',
        // token: localStorage.getItem('logintoken')
      },
      // rules 表单验证
      rules: {
        role_name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ],
        role_sign: [
          { required: true, message: '请输入角色签名', trigger: 'blur' }
        ]

      },
      formInline: {
        page: 1,
        ps: 10,
        role_name: ''
      },
      // 删除
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      newArr: [],
      // 数据权限
      RoleRight: [],
      RoleRightProps: {
        children: 'children',
        label: 'name'
      },
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  watch: {},

  /**
   * 创建完毕
   */

  created() {
    this.getdata(this.formInline)
    this.getModuleList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */

  methods: {
    // 获取角色列表
    getdata(parameter) {
      this.loading = true
      roleList(parameter)
        .then(res => {
          this.loading = false
          res = checkLogin(res)
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('获取角色列表失败，请稍后再试！')
        })

       
    },
    getModuleList(){

        ModuleList()
          .then(res => {
            res = checkLogin(res);
            this.treeData = res.data
          })
          .catch(err => {
            this.loading = false
            this.$message.error('菜单管理列表失败，请稍后再试！')
          })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      if (row != undefined && row != 'undefined') {
        // if(row.role_id == 1){
        //    this.$message({
        //       type: 'info',
        //       message: '无法操作超管!'
        //     })
        //   return false
        // }
        // 获取当前角色拥有权限
        const param = {role_id: row.role_id}
        roleInfo(param)
          .then(res => {
            if(res.code == 200){
              this.checkmenu = res.data
              this.editFormVisible = true
              this.title = '修改角色'
              this.editForm.role_id = row.role_id
              this.editForm.role_name = row.role_name
              this.editForm.role_sign = row.role_sign
            }else{
              this.$message({
                  type: 'error',
                  message: res.msg
                })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('系统错误！')
          })
        
      } else {
        this.editFormVisible = true
        this.title = '添加角色'
        this.editForm.role_id = ''
        this.editForm.role_name = ''
        this.editForm.role_sign = ''
      }
      var els = document.getElementsByClassName('el-table__expand-icon')
      console.log(els)
      for (let i = 0; i < els.length; i++) {
        els[i].click()
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      console.log(this.editForm)
      const key = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys());
      if(key.length <= 0){
          this.$message({
              type: 'info',
              message: '权限菜单必选!'
            })
          return false
      }
      console.log(key)
      // return false
     this.editForm.permission_id = JSON.stringify(key)
     console.log(this.editForm.permission_id)
    //  return false
      this.$refs[editData].validate(valid => {
        if (valid) {
          roleSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: '角色保存成功！'
                })
                 this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('角色保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除角色
    deleteUser(index, row) {
      if(row.role_id == 1){
        this.$message({
            type: 'info',
            message: '无法操作超管!'
          })
        return false
      }
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const delParam = {role_id:row.role_id}
          roleDelete(delParam)
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: '角色已删除！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('角色删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 数据权限
    menuAccess: function(index, row) {
      if(row.role_id == 1){
        this.$message({
            type: 'info',
            message: '无法操作超管!'
          })
        return false
      }
      this.$message({
            type: 'info',
            message: '暂不支持!'
          })
        return false
      this.menuAccessshow = true
      this.saveroleId = row.roleId
      const param = {role_id:row.roelId};
      RoleRightTree(param)
        .then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '获取权限成功'
            })
            // this.changemenu(res.data.data)
            // this.RoleRight = this.changeArr(res.data.data)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('获取权限失败，请稍后再试！')
        })
    },
    // 选中菜单
    changemenu(arr) {
      let change = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].checked) {
          change.push(arr[i].id)
        }
      }
      this.checkmenu = change
    },
    // tree 递归
    changeArr(list) {
      var temptree = [],
        tree = [],
        items = []
      for (var i in list) {
        if (!temptree[list[i].id]) {
          var trow = {
            id: list[i].id,
            pId: list[i].pId,
            name: list[i].name,
            open: list[i].open,
            checked: list[i].checked,
            children: []
          }
          temptree[list[i].id] = trow
          items.push(trow)
        }
        if (list[i].uid > 0) {
          temptree[list[i].id]['children'].push({
            id: list[i].id,
            pId: list[i].pId,
            name: list[i].name,
            open: list[i].open,
            checked: list[i].checked,
            children: []
          })
        }
      }

      for (var j in items) {
        if (temptree[items[j].pId]) {
          temptree[items[j].pId]['children'].push(temptree[items[j].id])
        } else {
          tree.push(temptree[items[j].id])
        }
      }
      temptree = null
      items = null
      return tree
    },
    // 菜单权限-保存
    menuPermSave() {
      let parm = {
        roleId: this.saveroleId,
        moduleIds: ''
      }
      let node = this.$refs.tree.getCheckedNodes()
      let moduleIds = []
      if (node.length != 0) {
        for (let i = 0; i < node.length; i++) {
          moduleIds.push(node[i].id)
        }
        parm.moduleIds = JSON.stringify(moduleIds)
      }
      RoleRightSave(parm)
        .then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '权限保存成功'
            })
            this.menuAccessshow = false
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('权限保存失败，请稍后再试！')
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'perm') {
        this.menuAccessshow = false
      }
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.ph-container {
  margin: 0 auto;
  max-width: 1680px;
  min-width: 1024px;
 }
</style>

 


// WEBPACK FOOTER //
// src/views/system/Role.vue